import { createRouter,createWebHistory } from 'vue-router'
import { useCookies } from "vue3-cookies";
import { useAuthStore } from '@/stores/auth';
import { validate_admin_token } from '@/api/admin_api.js';

import routes from './routes.js'

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition;
        } else if (to.hash) {
          return new Promise((resolve) => {
            // Ensure the element is in the DOM before trying to scroll
            setTimeout(() => {
              const element = document.querySelector(to.hash);
              if (element) {
                // Calculate position with offset
                const top = element.getBoundingClientRect().top + window.pageYOffset - 50;
                resolve({ left: 0, top, behavior: 'smooth' });
              } else {
                resolve({ left: 0, top: 0, behavior: 'smooth' });
              }
            }, 0); // setTimeout with 0 delay ensures the DOM is updated
          });
        } else {
          return { left: 0, top: 0 };
        }
    }      
});

router.beforeEach(async (to, from, next) => {
    const { cookies } = useCookies();
    const authStore = useAuthStore();
    const admin_auth_token = cookies.get('admin_auth_token'); // Check for auth token in cookies

    // Wait for the store to initialize if it hasn’t already
    if (!authStore.isInitialized) {
        await authStore.initializePinia();
    } 

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!admin_auth_token) {
        // If not authenticated, redirect to login
        cookies.remove('admin_auth_token');
        return next('../admin/login');
      } else {
        try {
          const response = await validate_admin_token(admin_auth_token);
          if (response.success) {
            return next();
          } else {
              cookies.remove('admin_auth_token');
              return next('../admin/login');
          }
        } catch (error) {
            console.log(error);
            cookies.remove('admin_auth_token');
            return next('../admin/login');
        } 
      }
    } else if (to.matched.some(record => record.meta.showLeftMenu)) {
        if (!authStore.myself) {
            await authStore.initializePinia();
            next();
        } else {
            const subscription_status = authStore.subscription_status;
            if (subscription_status && !subscription_status.subscription_active && to.name !== 'Profile' && to.name !== 'Billing') {
              return next({ name: 'Profile', query: { showDialog: 'true' } });
            } else {
              return next();
            }
        }
    } else {
        return next();
    }
  });

export default router